"use client";
import { useState } from "react";

import SellsForm from "@/components/sells-form";

import Container from "@/components/ui/Container";

import { validateForm } from "@/lib/validation";
import { useRouter } from "next/navigation";
import { addNewB2bCommand } from "@/lib/api";

import popcardMetrics from "@/translation/order/popcardMetrics";

const Metrics = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState<any>({
    fullName: {
      label: {
        fr: "Nom et Prénom*",
        ar: "الاسم واللقب*",
        en: "Full Name*",
      },
      name: "fullName",
      placeholder: {
        fr: "Votre nom et prénom",
        ar: "أدخل إسمك الكامل",
        en: "Your full name",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    enterprise: {
      label: {
        fr: "Entreprise *",
        ar: "الشركة *",
        en: "Company*",
      },
      name: "Entreprise",
      placeholder: {
        fr: "Votre entreprise",
        ar: "أدخل إسم شركتك",
        en: "Your company",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    email: {
      label: {
        fr: "Adresse Email*",
        ar: "البريد الإلكتروني*",
        en: "Email Address*",
      },
      placeholder: {
        fr: "Votre email",
        ar: "أدخل بريدك الإلكتروني",
        en: "Your email",
      },
      name: "Email",
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    phone: {
      label: {
        fr: "Téléphone*",
        ar: "الهاتف*",
        en: "Phone*",
      },
      name: "Téléphone",
      placeholder: {
        fr: "Votre Téléphone",
        ar: "أدخل رقم هاتفك",
        en: "Your phone number",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    size: {
      type: "select",
      label: {
        fr: "Quantité*",
        ar: "الكمية*",
        en: "Quantity*",
      },
      name: "La taille de votre entreprise",
      placeholder: {
        fr: "La taille de votre entreprise",
        ar: "حجم شركتك",
        en: "The size of your company",
      },
      options: ["10 - 20", "20 - 30", "30 - 40", "40 - 50", "Plus de 50"],
      values: ["10 - 20", "20 - 30", "30 - 40", "40 - 50", "Plus de 50"],
      value: "10 - 20",
      error: { fr: "", ar: "", en: "" },
    },
  });

  const onSubmit = async (e: any) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    const isValidationError = await validateForm(fields, setFields, [
      "email",
      "phone",
      "city",
      "enterprise",
      "fullName",
      "size",
    ]);

    if (isValidationError) {
      return;
    }
    const fullName = fields.fullName.value;
    const spaceIndex = fullName.indexOf(" ");
    const first_name =
      spaceIndex === -1 ? fullName : fullName.substr(0, spaceIndex);
    const last_name = spaceIndex === -1 ? "" : fullName.substr(spaceIndex);
    const data = await addNewB2bCommand({
      email: fields.email.value,
      first_name,
      last_name,
      enterprise: fields.enterprise.value,
      phone: fields.phone.value,
      qty: fields.size.value,
    });

    if (data) {
      router.push("/thank-you/metrics/" + data.ref);
    }

    setLoading(false);
  };
  return (
    <>
      <Container className="grid grid-cols-6 gap-8 justify-items-center py-[5rem]">
        <iframe
          loading="lazy"
          className="col-span-6 sm:col-span-3 aspect-square w-full rounded-xl border border-neutral-800 max-w-full"
          src="https://www.youtube.com/embed/v1qZA-Hk6HE?si=2stf0AxAr-xry-14"
          title="YouTube video player"
        ></iframe>
        <SellsForm
          onSubmit={onSubmit}
          fields={fields}
          setFields={setFields}
          className="col-span-6 sm:col-span-3"
          name={popcardMetrics.title}
          description={popcardMetrics.description}
          checked={[
            popcardMetrics.partageIlimite,
            popcardMetrics.collectIllimite,
            popcardMetrics.editableProfiles,
            popcardMetrics.personalize,
            popcardMetrics.kpi,
            // popcardMetrics.backoffice,
          ]}
          isMetrics={true}
          whatsappMessage={false}
          unchecked={[]}
          colors={[]}
          oldPrice={390}
          currentPrice={290}
        />
      </Container>
    </>
  );
};

export default Metrics;
